import { CB_DELIVERY_CODE } from "../../../constant/contant";
import request from "../../../utils/wapRequest";
const url = process.env.VUE_APP_WAP_API;
const urlV2 = process.env.VUE_APP_BASE_API_V2;
const urlHio = process.env.VUE_APP_BASE_API_HIO;
const BASE_API = process.env.VUE_APP_BASE_API;
const BASE_URL_LOGIN = process.env.VUE_APP_BASE_LOGIN;

const GlobalAPI = {
  getFacilityDetail(query) {
    return request({
      url: `${url}/get_facility_review`,
      method: "GET",
      params: query
    });
  },
  searchFacility(data) {
    return request({
      url: `${BASE_URL_LOGIN}/services/get_list_general_bill_by_place`,
      method: "POST",
      data
    });
  },
  getDetailBill(billId) {
    return request({
      url: `${BASE_URL_LOGIN}/services/get_bill_detail_for_bank?bill_id=${billId}&general_payment_code=${CB_DELIVERY_CODE}${billId}`,
      method: "GET"
    });
  },
  createBookingForBank(body) {
    return request({
      url: `${urlV2}/booking_pax/create_booking_for_bank?uid=36`,
      method: "POST",
      body: body
      // params: query
    });
  },
  create_request_for_wap(data) {
    return request({
      url: `${BASE_API}/create_request_for_wap_wgroup`,
      method: "POST",
      data
    });
  },
  confirm_otp_for_wap(params) {
    return request({
      url: `${BASE_API}/confirm_otp_for_wap_wgroup`,
      method: "POST",
      params
    });
  },
  create_request_for_wap_point(data) {
    return request({
      url: `${BASE_API}/create_request_for_wap_point`,
      method: "POST",
      data
    });
  },
  confirm_otp_for_wap_point(params) {
    return request({
      url: `${BASE_API}/confirm_otp_for_wap_point`,
      method: "GET",
      params
    });
  },
  list_method_payment(params) {
    return request({
      url: `${urlHio}/list_method_payment`,
      method: "GET",
      params
    });
  }
};

export { GlobalAPI as default };
